const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fillRule: "nonzero"
    },
    d: "M38.17,38.11l-0.03,0.03l5.32,5.32l-2.54,2.54l-5.548,-5.548c-3.23,2.237 -7.149,3.548 -11.372,3.548c-11.04,0 -20,-8.96 -20,-20c0,-4.223 1.311,-8.142 3.548,-11.372l-5.548,-5.548l2.54,-2.54l5.32,5.32l0.03,-0.03l14.31,14.31l-0.03,0.03l2.83,2.83l0.03,-0.03l11.14,11.14Zm-25.506,-30.586c3.222,-2.222 7.128,-3.524 11.336,-3.524c11.04,0 20,8.96 20,20c0,4.208 -1.302,8.114 -3.524,11.336l-10.906,-10.906l8.43,-8.43l-2.82,-2.84l-8.44,8.44l-14.076,-14.076Zm8.966,19.186l-1.63,1.63l-7.18,-7.16l-2.82,2.82l10,10l4.46,-4.46l-2.83,-2.83Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOff);
export default __webpack_public_path__ + "static/media/check-circle-off.d4d7f7f642b1876154a999c655ff7be3.svg";
export { ForwardRef as ReactComponent };